export const PRO_FEATURES = [
    "Access to the most intelligent AI models",
    "Allow the AI to use tools and work agentically",
    "Customization to tailor the AI to your needs"
];
